export const STORAGE_KEY = 'futbolero.counterToken';

/**
 * El token viaja en el fragmento de la URL, no en el query string: así no
 * llega al server, no queda en sus logs ni en el header Referer.
 */
export function readTokenFromHash(hash: string): string | null {
  if (!hash) return null;
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  const token = params.get('t');
  return token && token.length > 0 ? token : null;
}

export function storeToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Modo privado: la sesión dura lo que dure la pestaña. No es un error.
  }
}

export function loadToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ídem
  }
}
